const bookings ={
    list: {
        bookingList:'قائمة الحجوزات',
        search: 'ابحث باستخدام رقم الحجز او بأسم العميل',
        filter:{
            filtersPlaceHolders:{
                filterByBranchName: 'اسم الفرع',
                filterByServiceProvider:'مقدم الخدمة',
                filterByStartDate:'من تاريخ ',
                filterByEndDate:'إلى تاريخ ',
                filterByBookingsStatus:'حاله',
                dateLabel:'تاريخ'
            }
        },
        noData: 'لا توجد حجوزات حتى اللآن' 
    },
    status:{
        upcoming: 'قادمه', 
        ongoing: 'حاليه', 
        pending_payment: 'في انتظار الدفع', 
        completed: 'مكتملة', 
        canceled: 'أُلغيت',
    },
    details: {
        booking: 'حجز',
        appointmentId: 'رقم الحجز',
        date: 'تاريخ',
        status: 'الحالة',
        paymentMethod: 'طريقة الدفع',
        cash: 'نقدي',
        online:'دفع إلكتروني',
        location: 'المكان',
        in_place:'في الفرع',
        home: 'في منزل العميل',
        providerName: 'مقدم الخدمة',
        branchName: 'اسم الفرع',
        customerName: 'اسم العميل',
        customerPhoneNumber:'رقم تليفون العميل',
        customerNote:'ملاحظات العميل',
        noNotes:'لا توجد ملاحظات',
        services:'الخدمات',
        emptyState:' لا يوجد خدمات حتى الآن !',
        feesRange:'مدى الرسوم',
        fees: 'الرسوم',
        sar:' ريال سعودي ',
        duration: 'المدة',
        from:' من',
        to:' إلى ',
        description: 'الوصف',
        employeeName: ' الموظف',
        customerReported: '"العميل أبلغ أن"الموظف لم يحضر',
        employeeReporeted: '"الموظف أبلغ أن"العميل لم يحضر',
        reported: 'أُبلغ',
        employeeDidNotShowUp: 'الموظف لم يحضر',
        customerDidiNotShowUP: 'العميل لم يحضر',
        markAsDone: 'تم اكتمال الخدمة ',
        resolve: 'العميل حضر',
        editFees: 'تعديل الرسوم',
        remining:'متبقية',
        feesInputLabel:' ادخل قيمة الرسوم المطلوبة لخدمة ',
        service: 'خدمة',
        feesHint: 'يجب أن تبدأ قيمة الرسوم من ',
        feesInputPlaceholder: 'الرسوم مطلوبة',
        cancelUpcomingPopupContent: 'هل متأكد من إلغاء هذا الحجز ؟',
        cancelBooking: 'إلغاء الحجز',
        cancelService:'إلغاء الخدمة',
        refuseToCancelPopupContent: 'هذا الحجز لا يمكن إلغائه لإن لديه خدمة مكتملة.',
        bookingCancelationReasonLabel:'اختار سبب إلغاء هذا الحجز',
        serviceCancelationReasonLabel:'اختار سبب إلغاء هذه الخدمة',
        cancellationReason: 'سبب الإلغاء',
        cancelledBy: 'أٌلغي من',
        Admin:'المسؤول',
        ServiceProviderManager:'مقدم لخدمة',
        Employee:'الموظف',
        Customer:'العميل',
        deletedBranch:'فرع ممسوح',
        deletedProvider:'مقدم خدمة ممسوح',
        addAnotherService: 'أضف خدمة أخرى',
        customerHasPaid:'لقد دفع العميل',
        customerHasPaidPopupContent: 'هل أنت متأكد أن العميل قد دفع ؟',
        totalAmountWithoutVAT:' المبلغ الإجمالي بدون ضريبة القيمة المضافة',
        VAT:'القيمة المضافة% ',
        totalAmountWithVAT: 'المبلغ الإجمالي بضريبة القيمة المضافة',
        paymentConfirmedBy: 'تم تأكيد الدفع بواسطة',
        resoveBtn:'حل',
        problemLabel: 'لقد أُبلغ عن مشكلة',
        resolveProblem:'حل المشكلة',
        setAppointmentAsCompleted:'اكمال الموعد',
        selectAction:'اختار حل لهذه المشكلة',
        resolutionAmount:{
            placeholder: ' ادخل مبلغ التصالح',
            label:'مبلغ التصالح'
        },
        customerPaidAmount:{
            placeholder: 'ادخل المبلغ الذي دفعه العميل',
            label:'المبلغ الذي دفعه العميل'
        },
        serviceType: 'نوع الخدمة',
        multi_session: 'جلسات متعددة',
        single_service: 'خدمة واحدة',
        remainingSessions: 'الجلسات المتبقية',
        sessionsExpiry: 'انتهاء الجلسات',
        session: 'جلسة',
        sessions: 'جلسات',
        noDescription: 'لا يوجد وصف',

    },
    addAnotherService:{
        searchPlaceholder: 'ابحث باستخدام اسم الخدمة',
        specialtyFilterPlaceholder: 'التخصص',
        noData: 'لا يوجد خدمات آخرى',
        mins: 'دقيقة',
        employeePlaceHolder: 'لم يتم اختار موظف حتى الآن',
        employeeLabel: 'اختار موظف',
        employeeList: 'قائمة الموظفين',
        employeeSearchPlaceolder:'ابجث باستخدام اسم الموظف أو رقم الموظف',
        counterLabel: 'خدمات مختارة',
        seeMore:'مشاهدة المزيد',
        noEmployeePlaceholder: ' لا يمكن اختيار هذه الخدمة لأن غير معين موظفين عليها '
    }

};

export default bookings;